import * as React from 'react';

import type {Edition} from '../edition-thumbnail-list/types';
import {FormattedTimestamp} from '../timestamp/formatted-timestamp';

export function getEditionMetadata(edition: Edition): React.ReactNode | null | undefined {
    const scheduledSendTime = edition.sendTime || edition.scheduledTime;

    if (edition.status === 'TEMPLATE') {
        return <span className='flex'>{edition.campaignName}</span>;
    } else if (edition.status === 'SCHEDULED' && scheduledSendTime) {
        return (
            <span className='flex'>
                Sending on &nbsp;
                <FormattedTimestamp datetime={scheduledSendTime} format='MMM Do, YYYY' />
            </span>
        );
    } else if ((edition.status === 'SENT' || edition.status === 'SENDING') && scheduledSendTime) {
        return (
            <span className='flex'>
                Sent on&nbsp;
                <FormattedTimestamp datetime={scheduledSendTime} format='MMM Do, YYYY' />
            </span>
        );
    } else if (edition.modifiedTime) {
        return (
            <span className='flex'>
                Edited&nbsp;
                <FormattedTimestamp datetime={edition.modifiedTime} format='MMM Do, YYYY' />
            </span>
        );
    } else {
        return (
            <span className='flex'>
                Created&nbsp;
                <FormattedTimestamp datetime={edition.createdTime} format='MMM Do, YYYY' />
            </span>
        );
    }
}
